import { useAsyncData } from '#imports'
import { type ComputedRef, computed } from 'vue'

import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import type { ModelComparisonParentProduct } from '~/api/models-comparison/types'

type SelectOption = { id: string; label: string; value: string }

function toSelectOptions(
  products: ModelComparisonParentProduct[] | undefined,
): SelectOption[] {
  return (products ?? []).map((p) => ({
    id: p.slug,
    label: p.name,
    value: p.slug,
  }))
}

export function useComparisonOptions(
  slugA: ComputedRef<string>,
  slugB: ComputedRef<string>,
) {
  const $httpFetch = useHttpFetch()

  const { data: dataA } = useAsyncData(
    () => `comparison-options-${slugA.value}`,
    () =>
      $httpFetch('/models-comparison/parent-products/:slug/comparisons', {
        pathParams: { slug: slugA.value },
      }),
    { server: false, watch: [slugA] },
  )

  const { data: dataB } = useAsyncData(
    () => `comparison-options-${slugB.value}`,
    () =>
      $httpFetch('/models-comparison/parent-products/:slug/comparisons', {
        pathParams: { slug: slugB.value },
      }),
    { server: false, watch: [slugB] },
  )

  const optionsPerProduct = computed<SelectOption[][]>(() => [
    toSelectOptions(dataB.value?.parentProducts).filter(
      (opt) => opt.value !== slugA.value,
    ),
    toSelectOptions(dataA.value?.parentProducts).filter(
      (opt) => opt.value !== slugB.value,
    ),
  ])

  return { optionsPerProduct }
}
